import React from 'react';
interface Tab {
  id: string;
  label: string;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}
export function Tabs({
  tabs,
  activeTab,
  onChange,
  className = ''
}: TabsProps) {
  return <div className={`border-b border-gray-200 ${className}`} data-id="element-317">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs" data-id="element-318">
        {tabs.map(tab => <button key={tab.id} onClick={() => onChange(tab.id)} className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${activeTab === tab.id ? 'border-red-600 text-red-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `} aria-current={activeTab === tab.id ? 'page' : undefined} data-id="element-319">
            {tab.label}
          </button>)}
      </nav>
    </div>;
}